module.exports = __webpack_public_path__ + "img/美食.c92797af.jpg";